import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import React, { useState } from "react";

const SnackBarContext = React.createContext();

function SnackBarProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState({
    message: "خطایی رخ داده است.",
    actionTitle: "متوجه شدم",
    action: null,
    bottom: `calc(env(safe-area-inset-bottom) + 24px )`,
  });

  const openSnack = (state, config) => {
    if (config) {
      setConfig((prev) => {
        return {
          message: config.message || "خطایی رخ داده است.",
          actionTitle: config.actionTitle || "متوجه شدم",
          action: config.action,
          bottom: config.bottom || `calc(env(safe-area-inset-bottom) + 24px )`,
        };
      });
    }
    setOpen(state);
  };
  return (
    <SnackBarContext.Provider value={openSnack}>
      {children}
      <Snackbar
        sx={{
          bottom: {
            xs: config.bottom,
          },
          right: 8,
          left: 8,
        }}
        onClose={() => {
          setOpen(false);
        }}
        autoHideDuration={config.action ? null : 2000}
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        open={open}
        message={config.message}
        action={
          config.action && (
            <Button onClick={config.action} size="small" variant="text">
              {config.actionTitle}
            </Button>
          )
        }
      />
    </SnackBarContext.Provider>
  );
}

function useSnackBar() {
  const context = React.useContext(SnackBarContext);
  if (context === undefined) {
    throw new Error("useSnackBar must be used within a SnackBarProvider");
  }
  return context;
}

export { SnackBarProvider, useSnackBar };
